<template>
  <section class="tonal-chart">
    <h4 class="tonal-chart__title">Динамика тональности</h4>
    <template v-if="!reqPending">
      <dynamic-controls
        :controls-list="controlsList.data"
        @onClick="handleClick"
      ></dynamic-controls>
      <line-chart
        id="lineChart"
        :height="150"
        :chart-data="dataCollection"
        :options="options"
        :class="errorClass"
      ></line-chart>
      <template v-if="errorLoading"></template>
    </template>
    <table-preloader v-else></table-preloader>
  </section>
</template>

<script>
// components
import { LineChart } from '@/components/postsDynamicChart';
import dynamicControls from './components/dynamicControls.vue';
import TablePreloader from '@/components/preLoaders/tablePreloader.vue';

// api
import { getAdditionalInfoApi } from '@/api/posts';

export default {
  name: 'TonalChart',
  props: {
    openSidebar: {
      type: Boolean,
    },
  },
  data() {
    return {
      response: {},
      firstOpen: false,
      thread_id: process.env.VUE_APP_THREAD_ID,
      month: [
        'янв',
        'фев',
        'мар',
        'апр',
        'май',
        'июн',
        'июл',
        'авг',
        'сен',
        'окт',
        'ноя',
        'дек',
      ],
      reqPending: false,
      errorLoading: false,
      controlsList: {
        data: {
          hour: {
            title: 'часы',
            property: 'publicationsgrowthwithtrust',
            prepareLabels: elem => elem[0],
            active: false,
          },
          days: {
            title: 'дни',
            property: 'publicationsgrowthdaily',
            prepareLabels: (elem) => {
              const dateArr = elem[0].split('-');
              const month = parseInt(dateArr[1]) - 1;

              return [elem[0].slice(-2), this.month[month]];
            },
            active: true,
          },
        },
        activeProperty: 'publicationsgrowthdaily',
      },
      dataCollection: {},
      options: {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
          position: 'bottom',
        },
        scales: {
          xAxes: [{
            ticks: {
              fontSize: 10,
              fontFamily: 'Oswald',
              fontStyle: 'bold',
              beginAtZero: true,
            },
          }],
          yAxes: [{
            ticks: {
              beginAtZero: true,
              fontSize: 10,
              fontFamily: 'Oswald',
            },
          }],
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
    };
  },
  methods: {
    errorClass() {
      return this.errorLoading ? 'hideChart' : '';
    },
    handleClick(property) {
      if (this.controlsList.activeProperty !== property) {
        const controlKeys = Object.keys(this.controlsList.data);

        controlKeys.forEach((item) => {
          this.controlsList.data[item].active = !this.controlsList.data[item].active;
        });

        this.controlsList.activeProperty = property;
        this.getActiveAdditionalInfo();
      }
    },
    getActiveAdditionalInfo() {
      this.dataForChart = this.response.data[this.controlsList.activeProperty];
      this.$nextTick(() => {
        const elementWrap = document.querySelector('#lineChart');

        if (!elementWrap) {
          return;
        }

        const ctx = elementWrap.querySelector('canvas').getContext('2d');

        this.processLastHour();

        const negativeGradient = ctx.createLinearGradient(0, 0, 0, 400);
        negativeGradient.addColorStop(0, 'rgba(206, 43, 43, 0.6)');
        negativeGradient.addColorStop(1, 'rgba(206, 43, 43, 0.2)');

        const positiveGradient = ctx.createLinearGradient(0, 0, 0, 400);
        positiveGradient.addColorStop(0, 'rgba(0, 157, 72, 0.6)');
        positiveGradient.addColorStop(0.3, 'rgba(0, 157, 72, 0.2)');

        let prepareFunc = null;
        const controlKeys = Object.keys(this.controlsList.data);
        controlKeys.forEach((item) => {
          if (this.controlsList.data[item].active) {
            prepareFunc = this.controlsList.data[item].prepareLabels;
          }
        });

        this.dataCollection = {
          labels: this.dataForChart.total.map(elem => prepareFunc(elem)),
          datasets: [{
            label: 'Негативные',
            borderColor: '#ce2b2b',
            borderWidth: 1,
            pointRadius: 2,
            pointBackgroundColor: '#ce2b2b',
            pointBorderColor: 'transparent',
            backgroundColor: negativeGradient,
            lineTension: 0,
            data: this.dataForChart.negative.map(elem => elem[1]),
          },
          {
            label: 'Позитивные',
            borderColor: '#009d48',
            borderWidth: 1,
            pointRadius: 2,
            pointBackgroundColor: '#009d48',
            pointBorderColor: 'transparent',
            backgroundColor: positiveGradient,
            lineTension: 0,
            data: this.dataForChart.positive.map(elem => elem[1]),
          }],
        };
      });
    },
    getAdditionalInfo() {
      this.reqPending = true;
      const params = {
        thread_id: this.thread_id,
      };
      getAdditionalInfoApi(params)
        .then((resp) => {
          this.response = resp;
          this.reqPending = false;
          this.getActiveAdditionalInfo();
        })
        .catch(() => {
          this.errorLoading = true;
        });
    },
    processLastHour() {
      const lastElement = this.dataForChart.total[this.dataForChart.total.length - 1];
      this.lastHourTotal = lastElement[1];
      this.lastIndexHourTotal = this.dataForChart.total.indexOf(lastElement);

      if (!this.lastHourTotal) {
        for (const item in this.dataForChart) {
          this.dataForChart[item].splice(this.lastIndexHourTotal, 1);
        }
      }
    },
  },
  mounted() {
    this.getAdditionalInfo();
  },
  watch: {
    openSidebar() {
      this.getAdditionalInfo();
    },
  },
  components: {
    LineChart,
    dynamicControls,
    TablePreloader,
  },
};
</script>

<style>
.tonal-chart {
  margin: 10px 0 10px 0;
  width: auto;
  min-height: 175px;
  background-color: #ffffff;
  border-radius: 4px;
}

.tonal-chart__title {
  padding: 0 0 7px 0;
  margin: 0 0 10px 0;
  font-family: "Oswald", "Arial", sans-serif;
  font-style: normal;
  font-weight: 300;
  font-size: 18px;
  line-height: normal;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  border-bottom: 1px solid #c4c4c4;
}

.hideChart {
  display: none;
}

@media (max-width: 1040px) {
  .tonal-chart {
    margin: 10px 0 20px 0;
  }
}
</style>
